import styled from "@emotion/styled";
import variables from '../../styles/variables.module.scss';


export const CustomH3 = styled.h3<{ error?: boolean; }>`
  color: ${props => props.error ? variables.color_warn : variables.text_color};
`;